import type { ComponentProps, MouseEvent } from "react";
import { Suspense, useState } from "react";

import { ROUTES } from "@/constants/routes";
import { cn } from "@/utils/cn";

import { LegalDrawer, type LegalType } from "./LegalDrawer";
import { Link } from "./Link";

const LEGAL_URLS: Record<LegalType, string> = {
  terms: ROUTES.TERMS,
  privacy: ROUTES.PRIVACY,
  subscription: ROUTES.TERMS,
};

interface LegalRedirectDrawerProps extends Omit<ComponentProps<typeof Link>, "href"> {
  type: LegalType;
}

export const LegalRedirectDrawer = ({
  type,
  children,
  onClick,
  className,
  ...props
}: LegalRedirectDrawerProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const url = LEGAL_URLS[type];

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    const isMobile = window.matchMedia("(max-width: 767px)").matches;

    if (isMobile) {
      e.preventDefault();
      setIsOpen(true);
    }

    onClick?.(e);
  };

  return (
    <>
      <Link
        href={url}
        target="_blank"
        onClick={handleClick}
        className={cn("text-url underline", className)}
        {...props}
      >
        {children}
      </Link>
      <Suspense>
        <LegalDrawer type={isOpen ? type : null} onClose={() => setIsOpen(false)} />
      </Suspense>
    </>
  );
};
